import { atom } from "recoil";

interface IAddress {
  street: string;
  state_region: string;
  zip_code: string;
  country: string;
  city: string;
}

interface ISelectedCard {
  ccNumber: boolean;
  expDate: boolean;
  cvc: boolean;
}

interface IBillingInfo {
  billingInfo?: {
    billing_address: IAddress;
    shipping_address: IAddress;
  };
  billingAddress?: IAddress;
  shippingAddress?: IAddress;
  name: string;
  selected: ISelectedCard;
  errors: {
    shippingAddress: {
      street: boolean;
      state_region: boolean;
      zip_code: boolean;
      country: boolean;
      city: boolean;
    };
    billingAddress: {
      street: boolean;
      state_region: boolean;
      zip_code: boolean;
      country: boolean;
      city: boolean;
    };
    ccNumber: boolean;
    expDate: boolean;
    cvc: boolean;
    name: boolean;
  };
  basePrice?: {
    price: number;
    tier: number;
  }[];
  externalUserPrice: number;
  adminPrice: number;
  setupFeePrice: number;
  customerId: string;
  activeUser: boolean;
  subscriptionId: string;
  termsAndConditions: boolean;
  customShipping: boolean;
  tier: number;
  admins?: number;
  externalUsers?: number;
  card?: {
    card: {
      brand: string;
      country: string | null;
      description?: string | null;
      exp_month: number;
      exp_year: number;
      fingerprint?: string | null;
      funding: string;
      iin?: string | null;
      issuer?: string | null;
      last4: string;
    };
  };
  subscriptionEndDate: number; // Timestamp

  cardName?: string;
  vatId?: string;
  companyName?: string;
  additionalSum: number;
  active?: boolean;
  update: boolean;
  oldPrice?: number;
  initialAdmins: number;
  initialExternalAdmins: number;
}

const DEFAULT_VALUE = {
  billingAddress: {
    street: "",
    state_region: "",
    zip_code: "",
    country: "",
    city: "",
  },

  shippingAddress: {
    street: "",
    state_region: "",
    zip_code: "",
    country: "",
    city: "",
  },
  name: "",
  selected: {
    ccNumber: false,
    expDate: false,
    cvc: false,
  },
  errors: {
    shippingAddress: {
      street: false,
      state_region: false,
      zip_code: false,
      country: false,
      city: false,
    },
    billingAddress: {
      street: false,
      state_region: false,
      zip_code: false,
      country: false,
      city: false,
    },
    ccNumber: false,
    expDate: false,
    cvc: false,
    name: false,
  },
  quantity: 0,
  customerId: "",
  activeUser: false,
  subscriptionId: "",
  termsAndConditions: false,
  customShipping: false,
  adminPrice: 0,
  externalUserPrice: 1,
  setupFeePrice: 0,
  subscriptionEndDate: 0,
  admins: 0,
  externalUsers: 0,
  tier: 0,
  additionalSum: 0,
  update: false,
  initialAdmins: 0,
  initialExternalAdmins: 0,
};

export const billingAtom = atom<IBillingInfo>({
  key: "billing",
  default: DEFAULT_VALUE,
});

export const newBillingAtom = atom<IBillingInfo>({
  key: "newBilling",
  default: DEFAULT_VALUE,
});
